import React from 'react';
import { useTranslation } from 'react-i18next';

import closeIcon from '../../../assets/close-button.svg';

import { ModalContainer } from '../../common';
import ScrollableDiv from '../../common/ScrollableDiv';
import { ActionButton, PetCloudInput } from '../../common/petCloud';

import { usePetTagModal } from '../hooks/usePetTagModal';

import './PetTagModal.css';

const PetTagModal = ({
  isVisible = false,
  petId = '',
}) => {
  const { t } = useTranslation('myPets');
  const messageToFinderMaxLength = 2000;

  const {
    addButtonDisabled,
    familyMemberInfo,
    handleFamilyMemberNameInput,
    handleFamilyMemberPhoneNumberInput,
    handleMessageToFinderInput,
    handleOnBlurPetTag,
    handlePetTagClose,
    handlePetTagInput,
    handleSavePetTagButton,
    isEditMode,
    isPetTagInfoRequestStarted,
    MessageToFinder,
    saveButtonDisabled,
    successPetTagPost,
    TagNumber,
    tagNumberErrorMessage,
    onBlurPhoneNumberField,
    onFocusPhoneNumberField,
    showNumber,
  } = usePetTagModal({ petId });

  return (
    <ModalContainer show={isVisible}>
      <ScrollableDiv className="Pet-tag-modal-main-container" tabIndex={-1}>
        <div className="Pet-tag-modal-title-container">
          <h3>{t('PetTagModal.title')}</h3>

          <button
            className="Pet-tag-modal-close-icon-container"
            id="closeIconAddPetModal"
            onClick={handlePetTagClose}
            type="button"
          >
            <img
              alt="Close"
              className="Pet-tag-modal-close-icon"
              src={closeIcon}
            />
          </button>
        </div>

        <p className="Pet-tag-modal-description">
          {t('PetTagModal.description')}
        </p>

        <div className="Pet-tag-modal-content-container">
          <div className="Pet-tag-modal-tag-input-container">
            <PetCloudInput
              error={tagNumberErrorMessage}
              onBlur={handleOnBlurPetTag}
              onChange={handlePetTagInput}
              placeholder={t('PetTagModal.exampleTagNumber')}
              title={`${t('PetTagModal.tagNumberField')}*`}
              value={TagNumber}
            />
          </div>

          <PetCloudInput
            className="Pet-tag-modal-finder-input"
            isTextArea
            maxLength={messageToFinderMaxLength}
            onChange={handleMessageToFinderInput}
            placeholder={t('PetTagModal.exampleMessageFinder')}
            title={t('PetTagModal.messageToFinderField')}
            value={MessageToFinder}
          />

          <h4 className="Pet-tag-modal-row-title">
            {t('PetTagModal.emergencyContactField', { number: '1*' })}
          </h4>

          <div className="Pet-tag-modal-row-container">
            <PetCloudInput
              className="Pet-tag-modal-contact-input"
              error={familyMemberInfo[0].nameErrorMessage}
              onChange={handleFamilyMemberNameInput(1)}
              placeholder={t('PetTagModal.fullName')}
              value={familyMemberInfo[0].name}
            />

            <PetCloudInput
              error={familyMemberInfo[0].phoneNumberErrorMessage}
              errorClassName="Pet-tag-modal-phone-error"
              onBlur={onBlurPhoneNumberField}
              onChange={handleFamilyMemberPhoneNumberInput(1)}
              onFocus={onFocusPhoneNumberField(0)}
              placeholder={t('PetTagModal.phoneNumber')}
              type="tel"
              value={showNumber(0)}
            />
          </div>

          <h4 className="Pet-tag-modal-row-title">
            {t('PetTagModal.emergencyContactField', { number: 2 })}
          </h4>

          <div className="Pet-tag-modal-row-container">
            <PetCloudInput
              className="Pet-tag-modal-contact-input"
              error={familyMemberInfo[1].nameErrorMessage}
              onChange={handleFamilyMemberNameInput(2)}
              placeholder={t('PetTagModal.fullName')}
              value={familyMemberInfo[1].name}
            />

            <PetCloudInput
              error={familyMemberInfo[1].phoneNumberErrorMessage}
              errorClassName="Pet-tag-modal-phone-error"
              onBlur={onBlurPhoneNumberField}
              onChange={handleFamilyMemberPhoneNumberInput(2)}
              onFocus={onFocusPhoneNumberField(1)}
              placeholder={t('PetTagModal.phoneNumber')}
              type="tel"
              value={showNumber(1)}
            />
          </div>

          <h4 className="Pet-tag-modal-row-title">
            {t('PetTagModal.emergencyContactField', { number: 3 })}
          </h4>

          <div className="Pet-tag-modal-row-container">
            <PetCloudInput
              className="Pet-tag-modal-contact-input"
              error={familyMemberInfo[2].nameErrorMessage}
              onChange={handleFamilyMemberNameInput(3)}
              placeholder={t('PetTagModal.fullName')}
              value={familyMemberInfo[2].name}
            />

            <PetCloudInput
              error={familyMemberInfo[2].phoneNumberErrorMessage}
              errorClassName="Pet-tag-modal-phone-error"
              onBlur={onBlurPhoneNumberField}
              onChange={handleFamilyMemberPhoneNumberInput(3)}
              onFocus={onFocusPhoneNumberField(2)}
              placeholder={t('PetTagModal.phoneNumber')}
              type="tel"
              value={showNumber(2)}
            />
          </div>
        </div>

        <div
          className={'Pet-tag-modal-footer-container'
            + ` ${familyMemberInfo[2].phoneNumberErrorMessage
              ? 'Pet-tag-modal-footer-container-margin' : ''}`}
        >
          <ActionButton
            disabled={isEditMode ? saveButtonDisabled : addButtonDisabled}
            loading={isPetTagInfoRequestStarted}
            onClick={handleSavePetTagButton}
            onSuccess={handlePetTagClose}
            success={successPetTagPost}
            title={isEditMode ? t('PetTagModal.saveButton')
              : t('PetTagModal.addButton')}
          />

          <ActionButton
            isSecondaryButton
            onClick={handlePetTagClose}
            title={t('PetTagModal.cancelButton')}
          />
        </div>
      </ScrollableDiv>
    </ModalContainer>
  );
};

export { PetTagModal };
